export const AI_CONFIG = {
  name: 'Olli',
  model: 'claude-sonnet-4-6',
  maxTokens: 2048,
  temperature: 0.7,
  avatarPlaceholder: null,
};

export const SUPPORTED_QUERIES = [
  'tax_calculation',
  'invoice_summary',
  'client_analysis',
  'deadline_info',
  'net_income',
  'inps_contributions',
  'threshold_85k',
  'general_fiscal',
];

export const SUGGESTED_QUESTIONS = [
  "Quanto devo mettere da parte per le tasse quest'anno?",
  "Crea una fattura da 1.500€ per Mario Rossi",
  "Quali fatture sono da incassare?",
  "Qual è il mio netto disponibile ad oggi?",
  "Quanto manca alla soglia degli 85.000€?",
  "Esporta le fatture in CSV",
];
